import { useState, useEffect } from 'react';

export function useDeviceId() {
  const [deviceId, setDeviceId] = useState('');

  useEffect(() => {
    let id = localStorage.getItem('swingslot_device_id');
    if (!id) {
      // Use cryptographically secure UUID instead of Math.random()
      id = crypto.randomUUID();
      localStorage.setItem('swingslot_device_id', id);
    }
    setDeviceId(id);
  }, []);

  return deviceId;
}
